import { TRANSLATED_OBIS } from '@/common/messages/meter/register/obis';
import type { IntlShape } from 'react-intl';
import { createFullOBIS } from '@enmon/commons/lib/enmon';
import type { MeterRegister } from '@enmon/commons';

export const getObisTranslation = (intl: IntlShape, meterRegister: Pick<MeterRegister, 'medium' | 'obis'>): string => {
  const { medium, obis } = meterRegister;

  const obisDescriptor = TRANSLATED_OBIS[medium]?.[obis];
  return obisDescriptor ? intl.formatMessage(obisDescriptor) : createFullOBIS(meterRegister);
};
